
(function(){
  function initGallery(root){
    root.querySelectorAll('[data-gallery]').forEach(function(gallery){
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if(!main || !thumbs.length) return;
      thumbs.forEach(function(btn){
        btn.addEventListener('click', function(){
          var src = btn.getAttribute('data-src');
          var alt = btn.getAttribute('data-alt') || '';
          if(src){ main.src = src; main.alt = alt; }
          thumbs.forEach(function(t){ t.classList.remove('active'); });
          btn.classList.add('active');
        });
      });
    });
  }
  function initSticky(){
    var bars = document.querySelectorAll('[data-pdp-sticky-bar]');
    bars.forEach(function(bar){
      var trigger = bar.getAttribute('data-trigger') || 'hero';
      var el = document.getElementById(trigger) || document.querySelector('[data-hero-trigger]');
      function check(){
        if(!el){ bar.classList.add('visible'); return; }
        bar.classList.toggle('visible', el.getBoundingClientRect().bottom < 0);
      }
      window.addEventListener('scroll', check, {passive:true});
      check();
    });
  }
  function initInci(){
    document.querySelectorAll('[data-inci-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var wrap = btn.closest('[data-inci]');
        var body = wrap && wrap.querySelector('[data-inci-body]');
        var chev = wrap && wrap.querySelector('[data-inci-chevron]');
        if(!body) return;
        var open = body.classList.toggle('open');
        if(chev) chev.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function initDragScroll(){
    document.querySelectorAll('[data-drag-scroll]').forEach(function(scroller){
      var down=false,startX,scrollLeft;
      scroller.addEventListener('mousedown',function(e){down=true;scroller.style.cursor='grabbing';startX=e.pageX-scroller.offsetLeft;scrollLeft=scroller.scrollLeft;});
      scroller.addEventListener('mouseleave',function(){down=false;scroller.style.cursor='grab';});
      scroller.addEventListener('mouseup',function(){down=false;scroller.style.cursor='grab';});
      scroller.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();scroller.scrollLeft=scrollLeft-(e.pageX-scroller.offsetLeft-startX)*1.5;});
    });
  }
  function initSmooth(){
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var target = document.querySelector(a.getAttribute('href'));
        if(target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth'}); }
      });
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initGallery(document);initSticky();initInci();initDragScroll();initSmooth();});
})();
